import React from "react";
import styles from "./index.module.scss";

export interface HelpActionsProps {
    onCreateNew: () => void;
}

export const HelpActions: React.FC<HelpActionsProps> = ({
    onCreateNew,
}) => {
    return (
        <div className={styles.actionsContainer}>
            <h1 className={styles.title}>Help items list</h1>

            <button
                type="button"
                className={styles.createNewButton}
                onClick={onCreateNew}
            >
                Create New
            </button>
        </div>
    );
};

export default HelpActions;